/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignGenerate } from '../../axios/campaignGenerate'
import type {
	CampaignGenerateError,
	CampaignGenerateRequest,
	CampaignGenerateResponse,
} from '../../types/CampaignGenerate'

export const campaignGenerateMutationKey = () => [{ url: '/campaigns/generate' }] as const

export type CampaignGenerateMutationKey = ReturnType<typeof campaignGenerateMutationKey>

export type CampaignGenerateVariables = {
	data: CampaignGenerateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::generate */
export function useCampaignGenerate<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignGenerateResponse,
		AxiosError<CampaignGenerateError>,
		CampaignGenerateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignGenerateMutationKey(),
		mutationFn: ({ data }: CampaignGenerateVariables) => campaignGenerate(data, config).then(res => res.data),
		...options,
	})
}
